import { ContestSegmentType, SlateLabelEnum } from '@betterpool/api-types/contests-service';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

type UseGetScheduleTitleArgs = {
  slateLabel: SlateLabelEnum;
  segmentType: ContestSegmentType;
  slates: ContestSlate[];
};

const useGetScheduleTitle = ({ slates, slateLabel, segmentType }: UseGetScheduleTitleArgs) => {
  const { t } = useTranslation('contest');

  const gamesCount = useMemo(() => slates.flatMap((slate) => slate.games)?.length, [slates]);
  const slatesCount = slates?.length;

  const segmentTitle = useMemo(() => {
    if (segmentType === ContestSegmentType.SINGLE_SLATE) {
      if (slateLabel === SlateLabelEnum.TOURNAMENT)
        return t('detail.schedule.title.tournament__hasPlural', { count: gamesCount });
      if (slateLabel === SlateLabelEnum.WEEK)
        return t('detail.schedule.title.week__hasPlural', { count: slatesCount });
      if (slateLabel === SlateLabelEnum.SLATE)
        return t('detail.schedule.title.slate__hasPlural', { count: slatesCount });
      return t('detail.schedule.title.slate__hasPlural', { count: slatesCount });
    }

    return t('detail.schedule.title.multiSlate');
  }, [segmentType, t, slateLabel, slatesCount, gamesCount]);

  return segmentTitle;
};

export default useGetScheduleTitle;
